import { useState } from 'react';

import { createContexts } from '@/js/libs/create-contexts';
import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef';

import useLocalStorage, { StorageKey } from 'src/hooks/useLocalStorage';

export const { useAuthVerificationContext } = createContexts({
  AuthVerification() {
    const { loadString, saveString, removeItem } = useLocalStorage();
    const [verificationEmail, setVerificationEmail] = useState<string | null>(() => loadString(StorageKey.VERIFICATION_EMAIL));

    const onVerificationInit = useCallbackRef((email: string) => {
      saveString(StorageKey.VERIFICATION_EMAIL, email);
      setVerificationEmail(email);
    });

    const onVerificationComplete = useCallbackRef(() => {
      removeItem(StorageKey.VERIFICATION_EMAIL);
      setVerificationEmail(null);
    });

    return {
      verificationEmail,
      onVerificationInit,
      onVerificationComplete,
    };
  },
});
